import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';

const show = defineMessage({
  type: 'papercuts-show' as const,
});

const hide = defineMessage({
  type: 'papercuts-hide' as const,
});

const reposition = defineMessage({
  type: 'papercuts-reposition' as const,
  payloadSchema: t.object({
    bottomOffset: t.optional(t.number),
    rightOffset: t.optional(t.number),
  }),
});

const pickingStart = defineMessage({
  type: 'papercuts-picking-start' as const,
});

const pickingEnd = defineMessage({
  type: 'papercuts-picking-end' as const,
});

export const papercutsControls = {
  show,
  hide,
  reposition,
  pickingStart,
  pickingEnd,
} as const;
